export default [
  {
    label: 'ID',
    key: 'notification_id',
    _style: 'width: 50px',
  },
  {
    label: 'アライアンス名 ',
    key: 'company',
    _style: 'min-width: 12%;',
  },
  { label: '表示場所 ', key: 'place', _style: 'min-width: 8%;' },
  { label: '表示順 ', key: 'order', _style: 'min-width: 70px;' },
  { label: 'タイトル ', key: 'title', _style: 'min-width: 17%;', slot: true },
  {
    label: 'リンク先 ',
    key: 'link',
    _style: 'min-width: 90px;',
    slot: true,
    sorter: false,
  },
  {
    label: '配信 ',
    key: 'filter',
    _style: 'min-width: 60px;',
    slot: true,
    sorter: false,
  },
  { label: 'ステータス ', key: 'status', _style: 'min-width: 10%;' },
  {
    label: '予定期間 ',
    key: 'schedule_start',
    _style: 'min-width: 12%;',
    slot: true,
  },
  { label: '作成者 ', key: 'created_name', _style: 'min-width: 90px;' },
  { label: '更新者 ', key: 'updated_name', _style: 'min-width: 90px;' },
  { label: '閲覧数 ', key: 'hits', _style: 'min-width: 80px;' },
  { label: 'クリック数 ', key: 'clicks', _style: 'min-width: 100px;' },
  { label: '実績期間 ', key: 'start', _style: 'min-width: 12%;', slot: true },
]
